import { Button, Icon, Modal } from "../design";
import "./guarantorCards.css";

const DeleteConfirationForDoc = ({
  isOpen,
  onClose,
  name,
  heading,
  description,
  btn1Text,
  btn2Text,
  btn1Functionality,
  btn2Functionality,
  submitLoading = false,
}) => (
  <Modal
    open={Boolean(isOpen)}
    onClose={onClose}
    size="sm"
    title={heading}
    description={description}
    actions={
      <>
        <Button
          variant="secondary"
          size="lg"
          onClick={btn1Functionality}
          disabled={submitLoading}
        >
          {btn1Text}
        </Button>
        <Button
          variant="danger"
          size="lg"
          onClick={btn2Functionality}
          loading={submitLoading}
        >
          {btn2Text}
        </Button>
      </>
    }
  >
    <div className="guarantor-confirm__who">
      <Icon name="fileText" />
      {name}
    </div>
  </Modal>
);

export default DeleteConfirationForDoc;
